<template>
  <div>
    <div class="player-info-top">
      <div class="top-btn">
        <router-link :to="{name: 'playerTeam'}">
          <button class="goBack"></button>
        </router-link>
      </div>
      <img :src="playerInfo.img" class="player-img" alt="">
      <div class="player-num">
        <div v-if="playerInfo.num01" class="num-text">
          <p>{{playerInfo.num01}}</p>
          <div class="num-logo"
               :class="{
                  one: playerInfo.num01.includes('1'),
                  four: playerInfo.num01.includes('4'),
                  seven: playerInfo.num01.includes('7')
               }"></div>
        </div>
        <div v-if="playerInfo.num02" class="num-text">
          <p>{{playerInfo.num02}}</p>
          <div class="num-logo"
               :class="{
                  one: playerInfo.num02.includes('1'),
                  four: playerInfo.num02.includes('4'),
                  seven: playerInfo.num02.includes('7')
               }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayerTopImg',
  props: [ 'playerNum', 'playerImg' ],
  data() {
    return {
      playerInfo: {
        num01 : '',
        num02: '',
      },
    }
  },
  watch: {
    playerNum: {
      handler: function () {
        if(this.playerNum === '') return;
        if(this.playerNum < 10) {
          this.playerInfo.num01 = this.playerNum.toString();
          this.playerInfo.num02 = '';
        } else {
          let arr = this.playerNum.toString().split("");
          this.playerInfo.num01 = arr[0];
          this.playerInfo.num02 = arr[1];
        }
      }
    },
    playerImg: {
      handler: function () {
        // 임시 (onerror도 추가해야함)
        this.playerInfo.img = `https://www.dragons.co.kr/${this.playerImg}`;
      }
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>
